export default __webpack_public_path__ + "static/media/us.09185275.svg";